import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { formatDateTime } from '@/shared/lib/format';
import type { Delivery } from '../api/draftsApi';
import { DeliveryStatusChip } from './DeliveryStatusChip';

export function DeliveryList({ deliveries }: { deliveries: Delivery[] }) {
  if (deliveries.length === 0) return null;
  return (
    <Stack component="ul" aria-label="Delivery status per recipient" sx={{ listStyle: 'none', p: 0, m: 0, border: 1, borderColor: 'divider', borderRadius: 1, '& > li + li': { borderTop: 1, borderColor: 'divider' } }}>
      {deliveries.map((d) => (
        <Stack component="li" key={d.id} direction="row" sx={{ gap: 1.5, alignItems: 'center', flexWrap: 'wrap', px: 1.5, py: 1 }}>
          <Typography variant="body2" sx={{ minWidth: 160 }}>{d.recipientName}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', minWidth: 120 }}>{d.phoneMasked}</Typography>
          <DeliveryStatusChip status={d.status} />
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>{formatDateTime(d.updatedAt)}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}
